import { Decimal, bn, ZERO } from './BigNumber';

export interface BuildingState {
  amount: number;
  bought: number;
  totalCookies: Decimal;
  level: number;
  free: number;
  minigameSave: string;
}

export interface UpgradeState {
  unlocked: boolean;
  bought: boolean;
}

export interface BuffState {
  typeId: string;
  name: string;
  maxTime: number;
  time: number;
  multCpS: number;
  multClick: number;
  add: number;
}

export interface PrestigeState {
  level: Decimal;
  heavenlyChips: Decimal;
  heavenlyChipsSpent: Decimal;
  heavenlyUpgrades: Set<string>;
  ascensionMode: number;
}

export interface DragonState {
  level: number;
  aura: number;
  aura2: number;
}

export interface WrinklerState {
  phase: number;  // 0=dead, 1=appearing, 2=feeding
  hp: number;
  sucked: Decimal;
  type: number;   // 0=normal, 1=shiny
}

export interface Preferences {
  particles: boolean;
  numbers: boolean;
  autosave: boolean;
  milk: boolean;
  warn: boolean;
  volume: number;
  musicVolume: number;
}

export interface GameState {
  cookies: Decimal;
  cookiesEarned: Decimal;
  cookieClicks: number;
  cookiesPs: Decimal;
  cookiesPsRaw: Decimal;
  cookiesPsRawHighest: Decimal;
  globalCpsMult: Decimal;

  startDate: number;
  lastSaveDate: number;
  sessionStartDate: number;

  buildings: Map<string, BuildingState>;
  upgrades: Map<string, UpgradeState>;
  achievements: Set<string>;
  buffs: Map<string, BuffState>;

  prestige: PrestigeState;
  dragon: DragonState;

  wrinklers: WrinklerState[];
  elderWrath: number;
  pledgeT: number;

  season: string;
  seasonT: number;

  lumps: number;
  lumpT: number;
  lumpRefill: number;
  lumpCurrentType: number;

  seed: string;
  bakeryName: string;

  prefs: Preferences;

  tickCount: number;
  bulkBuyAmount: number;
}

export function createDefaultState(): GameState {
  return {
    cookies: ZERO,
    cookiesEarned: ZERO,
    cookieClicks: 0,
    cookiesPs: ZERO,
    cookiesPsRaw: ZERO,
    cookiesPsRawHighest: ZERO,
    globalCpsMult: bn(1),

    startDate: Date.now(),
    lastSaveDate: Date.now(),
    sessionStartDate: Date.now(),

    buildings: new Map(),
    upgrades: new Map(),
    achievements: new Set(),
    buffs: new Map(),

    prestige: {
      level: ZERO,
      heavenlyChips: ZERO,
      heavenlyChipsSpent: ZERO,
      heavenlyUpgrades: new Set(),
      ascensionMode: 0,
    },

    dragon: { level: 0, aura: 0, aura2: 0 },

    wrinklers: [],
    elderWrath: 0,
    pledgeT: 0,

    season: '',
    seasonT: 0,

    lumps: -1,
    lumpT: 0,
    lumpRefill: 0,
    lumpCurrentType: 0,

    seed: generateSeed(),
    bakeryName: 'My bakery',

    prefs: {
      particles: true,
      numbers: true,
      autosave: true,
      milk: true,
      warn: true,
      volume: 50,
      musicVolume: 50,
    },

    tickCount: 0,
    bulkBuyAmount: 1,
  };
}

function generateSeed(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz';
  let seed = '';
  for (let i = 0; i < 5; i++) {
    seed += chars[Math.floor(Math.random() * chars.length)];
  }
  return seed;
}
